import { render } from "./cashier_nav.vue?vue&type=template&id=388d4efc&scoped=true"
import script from "./cashier_nav.vue?vue&type=script&lang=js"
export * from "./cashier_nav.vue?vue&type=script&lang=js"

import "./cashier_nav.vue?vue&type=style&index=0&id=388d4efc&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388d4efc"]])

export default __exports__